<template>
  <div class="filtro w-full">
    <base-button 
      id="interior" 
      @click="filtrarItems"
    >
      Interior
    </base-button>
    <base-button 
      id="exterior" 
      @click="filtrarItems"
    >
      Exterior
    </base-button>
  </div>
</template>

<script>
export default {
  props:{
  },
  emits: ['items-filtrados'],
  data() {
    return{
      itemsFiltrados: {
        interior: true,
        exterior: true,
        corto: true,
        largo: true
      },
    }
  },
  methods: {
    filtrarItems(event) {
      console.log('filtrar')
      const botonid = event.target.id
      const value =  !this.itemsFiltrados[botonid]
      const filtrosActualizados = {
        ...this.itemsFiltrados,
        [botonid]: value
      }
      this.itemsFiltrados = filtrosActualizados
      console.log(this.itemsFiltrados)
      this.$emit('items-filtrados', this.itemsFiltrados)
    }
  }
}
</script>

